<ngx-scanner-qrcode #scanner [config]="config" (event)="onEvent($event)">
</ngx-scanner-qrcode>

<!-- Necesario para poder hacer una foto -->
<canvas #canvas style="display: none;"></canvas>

<!-- Botón para capturar la imagen -->
<!-- <button (click)="captureImage()">Capture Image</button> -->


<div class="device-selector" *ngIf="showDeviceSelector && devices && devices.length > 0">
  <label for="deviceSelect">{{ "QRSCANNER.SELECTCAM" | translate }}</label>
  <select id="deviceSelect" [(ngModel)]="selectedDeviceId" (change)="onSelectDevice(selectedDeviceId)">
    <option *ngFor="let device of devices" [value]="device.deviceId">
      {{ device.label || device.deviceId }}
    </option>
  </select>
</div>